module.exports = __webpack_public_path__ + "img/courseFile.866ebd2b.svg";